import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';
import { AccessRequestNode } from './AccessRequestNode';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type AccessRequestNodesFragment = { __typename?: 'AccessRequestConnection', nodes: Array<{ __typename?: 'AccessRequest', id?: string | null, requestedAt?: string | null, hasAccountUser?: boolean | null, hasMemberLicense?: boolean | null, requestedResource?: { __typename?: 'Collection', id: string, name: string, collectionProject: { __typename?: 'Project', id: string, name: string } } | { __typename?: 'FileAsset', id: string, name: string, project?: { __typename?: 'Project', id: string, name: string } | null } | { __typename?: 'FolderAsset', id: string, name: string, folderAssetProject?: { __typename?: 'Project', id: string, name: string } | null, project?: { __typename?: 'Project', id: string, name: string } | null } | { __typename?: 'Project', id: string, name: string } | { __typename?: 'VersionStackAsset', id: string, name: string, project?: { __typename?: 'Project', id: string, name: string } | null } | null, requesterUser?: { __typename?: 'UserInfo', id: string, email: string, name?: string | null, profileImageUrl?: string | null, avatarColor?: Types.AvatarColor | null } | null }> };

export const AccessRequestNodes = /*#__PURE__*/ gql`
    fragment AccessRequestNodes on AccessRequestConnection {
  nodes {
    ...AccessRequestNode
  }
}
    ${AccessRequestNode}` as unknown as DocumentNode<AccessRequestNodesFragment, unknown>;

        

        
export const useAccessRequestNodesFragment = (
  input: string | Omit<UseFragmentOptions<AccessRequestNodesFragment, any>, 'fragment' | 'fragmentName'> | undefined | null
) => {
  const options = (() => {
    if (!input) return { from: null };
    if (typeof input === 'string') return { from: { id: input, __typename: 'AccessRequestConnection' } };
    return input;
  })();

  return useFragment<AccessRequestNodesFragment>({
    fragment: AccessRequestNodes,
    fragmentName: 'AccessRequestNodes',
    ...options,
  });
};
  
        